export default {
  data: function () {
    return {
      isReferModalVisible: this.initialReferModalVisible,
    };
  },
  methods: {
    onShowReferModal: function () {
      this.isReferModalVisible = true;
    },
    onHideReferModal: function () {
      this.isReferModalVisible = false;
    },
  },
};
